import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch} from "../../utils/Hooks";
import {getInsuranceRates} from "../../store/reducers/InsuranceRatesSlice";
import {InsuranceRatesTable} from "./components/insuranceRatesTable";

interface InsuranceRatesScreeProps {
}

export const InsuranceRatesScreen: React.FC<InsuranceRatesScreeProps> = () => {

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getInsuranceRates());
    }, []);

    return (
        <LoggedInView fullWidth={false}>
            <h1>Kindlustuse hinnad</h1>
            <InsuranceRatesTable />
        </LoggedInView>
    )

}